import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import EditForm from './components/form';
import { selectors as rootSelectors } from '../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content cpl-rules-create">
			<div className="container__content-title clearfix">
				<div className="container__content-title-position">
					<Link to='cpl-rules/' className="link">{ props.intl('Return to list of CPL rules') }</Link>
				</div>
				<div className="container__content-title-position">
					<h2 className="title">{ props.intl('Edit CPL rule') }</h2>
				</div>
			</div>
			<div className="container__content-body">
				<div className="form-container">
					<EditForm {...props} initialValues={props.getFieldsById(props.params.id)} editId={props.params.id} />
				</div>
			</div>
		</div>
	</Animate>
), 'cplRulesEdit');

export default connect(
	state => ({
		data: selectors.getData(state),
		progressBar: selectors.getProgressBar(state),
		getFieldsById: selectors.getFieldsById(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		error: selectors.getError(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/cpl-rules/edit.js